import React from 'react';

function Home() {
  return (
    <div>
      👋
    </div>
  )
}

export default Home;